import { Box, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import api_call from "../../globals/common_utilities/axios_old";
import moment from "moment";
import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./trainingListing.scss";
import TrainingGridListing from "../TrainingGridListing";
import TrainingListingFilter from "../TrainingListingFilter";
import WeekDays from "../weekDays";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import Loading from "../loader";
import Pagination from "@mui/material/Pagination";
import _ from "lodash";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import Cookies from "universal-cookie";
import NoDataFound from "../NoDataFound/NoDataFound";
import TrainingListingDetails from "../TraininglistingDetails/index";
import Google from "../../Images/google-cloud.svg";
import Aws from "../../Images/aws-cloud.svg";
const TrainingListing = (props) => {
  const { AllPageFilter } = useSelector((state) => state);
  console.log("from", AllPageFilter);
  const { state } = useLocation();
  const [gridview, setGridview] = useState(false);
  const listtogglestate = props?.history?.location?.state?.listtogglestate;
  const [listtoggle, setListToggle] = useState(listtogglestate ?? true);
  const [togglefilterButton, setTogglefilterButton] = useState(false);
  const [trainingList, setTrainingList] = useState();
  const [studioList, setStudioList] = useState();
  const [instructorList, setInstructorList] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState();
  const [offset, setOffset] = useState();
  const limit = 12;
  const filterBody = [
    offset,
    AllPageFilter?.TrainingFilter?.searchBytrainingName,
    AllPageFilter?.TrainingFilter?.studio,
    AllPageFilter?.TrainingFilter?.instructor,
    AllPageFilter?.TrainingFilter?.startDate,
    AllPageFilter?.TrainingFilter?.endDate,
  ];
  const [showTrainingListingDetails, setShowTrainingListingDetails] =
    useState(false);
  const [trainingData, setTrainingData] = useState();
  const [trainingID, setTrainingID] = useState();
  const showDetailPage = () => {
    setShowTrainingListingDetails(!showTrainingListingDetails);
  };
  const gotoDetailsPage = (training) => {
    setShowTrainingListingDetails(true);
    setTrainingData(training);
    setTrainingID(training?.id);
    // navigate(APP_ROUTES.TRAINING_LISTING_DETAILS, {
    //  state: {
    //      trainingList: trainingList,
    //      training: training,
    //      id: training?.id,
    //  },
    // });
  };
  const { loginResponse, loading, error } = useSelector((state) => {
    console.log("state-------->>>", state);
    return state.login;
  });
  const cookies = new Cookies();
  const {
    id,
    name,
    device_id,
    studio_id,
    role_id,
    role_code,
    token,
    token_uniq_id,
    email_id,
    username,
    is_email_verify,
  } = cookies.get("loginData");
  const status_json = {
    pending: {
      color: "white",
      background: "#FE9000",
      // color: '#FE9000',
      // background: '#2B251E',
      status: "Upcoming Training",
    },
    completed: {
      color: "white",
      background: "#1b18e7",
      // color: '#1b18e7',
      // background: '#2b365c9e',
      status: "Completed Training",
    },
    cancel: {
      color: "white",
      background: "#6f0938f0",
      // color: '#ed0c0c',
      // background: '#893a3a59',
      status: "Cancelled Training",
    },
    running: {
      color: "white",
      background: "#0BB427",
      // color: '#0BB427',
      // background: '#0B3F1B',
      status: "Running Training",
    },
    inprogress: {
      color: "white",
      background: "#a367a6",
      status: "Training in progress",
    },
    failed: {
      color: "white",
      background: "#ed0c0c",
      status: "Failed Training",
    },
  };
  // var startDate = moment().utc().startOf('week').format('YYYY-MM-DD');
  // var endDate = moment().utc().endOf('week').format('YYYY-MM-DD');
  var startDate = moment().format("YYYY-MM-DD");
  var endDate = moment().format("YYYY-MM-DD");
  var today = moment().format("YYYY-MM-DD");
  console.log("Start Date--:" + startDate);
  console.log("End Dat--e:" + endDate);
  function toggleFun() {
    setListToggle(!listtoggle);
  }
  function filterButtonToggleFun() {
    setTogglefilterButton(!togglefilterButton);
  }
  async function getTrainingList(filter) {
    // let from = moment().subtract(7, 'days').format('YYYY-MM-DD');
    let from = moment().format("YYYY-MM-DD");
    let end = moment().format("YYYY-MM-DD");
    let queryParam =
      role_code === "STUDIO_ADMIN"
        ? {
            limit: limit || 10,
            offset: offset || 0,
            is_active: true,
            studio_id: studio_id,
          }
        : role_code === "INSTRUCTOR"
        ? {
            limit: limit || 10,
            offset: offset || 0,
            is_active: true,
            instructor_id: id,
          }
        : {
            limit: limit || 10,
            offset: offset || 0,
            is_active: true,
          };
    if (
      filter?.searchBytrainingName !== "" &&
      filter?.searchBytrainingName !== undefined
    ) {
      queryParam.search_term = filter?.searchBytrainingName;
    }
    if (filter?.studio !== "" && filter?.studio !== undefined) {
      queryParam.studio_id = filter?.studio;
    } else if (state?.tcAdmin_id !== "" && state?.tcAdmin_id !== undefined) {
      queryParam.studio_id = state?.tcAdmin_id;
    }
    if (filter?.instructor !== "" && filter?.instructor !== undefined) {
      queryParam.instructor_id = filter?.instructor;
    } else if (
      state?.instructor_id !== "" &&
      state?.instructor_id !== undefined
    ) {
      queryParam.instructor_id = state?.instructor_id;
    }
    queryParam.from_date = filter?.startDate
      ? moment(filter?.startDate).format("YYYY-MM-DD")
      : from;
    queryParam.end_date = filter?.endDate
      ? moment(filter?.endDate).format("YYYY-MM-DD")
      : end;
    if (state?.redirect === "tcAdminTP" || state?.redirect === "instructorTP") {
      delete queryParam?.from_date;
      delete queryParam?.end_date;
    }
    if (state?.redirect === "tcAdminTP") {
      delete queryParam?.studio_id;
    }
    if (state?.redirect === "tcAdminTP") {
      queryParam =
        role_code === "INSTRUCTOR"
          ? {
              limit: limit || 10,
              offset: offset || 0,
              is_active: true,
              created_by: state?.instructor_id,
            }
          : {
              limit: limit || 10,
              offset: offset || 0,
              is_active: true,
              // created_by: state?.instructor_id,
              studio_id,
            };
    }
    setIsLoading(true);
    let { data } = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.GET_TRAINING_LISTING
      }`,
      filter?.searchBytrainingName
        ? role_code === "STUDIO_ADMIN"
          ? {
              search_term: filter?.searchBytrainingName,
              studio_id: studio_id,
            }
          : role_code === "INSTRUCTOR"
          ? {
              search_term: filter?.searchBytrainingName,
              instructor_id: id,
            }
          : {
              search_term: filter?.searchBytrainingName,
            }
        : queryParam
    );
    if (data?.data?.count) {
      setIsLoading(false);
      setPageCount(() => Math.ceil(data?.data?.count / limit));

      let training_data = data?.data?.rows?.map((res) => {
        console.log("kkk88888", res);
        let data = {
          ...res,
          status_colour:
            res?.status === "pending"
              ? status_json.pending
              : res?.status === "completed"
              ? status_json.completed
              : res?.status === "cancel"
              ? status_json.cancel
              : res?.status === "running"
              ? status_json.running
              : res?.status === "in-progress"
              ? status_json.inprogress
              : res?.status === "failed"
              ? status_json.failed
              : status_json.completed,
          noofdaysTraininig:
            moment(res?.session_end_date).diff(
              res?.session_start_date,
              "days"
            ) === 0
              ? 1
              : moment(res?.session_end_date).diff(
                  res?.session_start_date,
                  "days"
                ),
        };
        let dataRange = res?.training_dates?.filter(
          (data) =>
            moment(data.session_start_date).format("YYYY-MM-DD") >= startDate &&
            moment(data.session_end_date).format("YYYY-MM-DD") <= endDate
        );
        console.log("check date tange data----", dataRange);
        if (dataRange.length > 0) {
          let orderDate = _.orderBy(dataRange, ["session_start_date"], ["asc"]);
          let days = dataRange.map((data) => data.day);
          let diff = orderDate.filter(
            (day) => today <= day?.session_start_date
          );
          data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
          data.startDate = moment(res?.session_start_date).format("Do MMM ");
          data.startTime = moment(orderDate[0]?.session_start_date)
            .add(15, "minutes")
            .format("h:mm a");
          data.endTime = moment(
            orderDate[orderDate.length - 1]?.session_end_date
          )
            .subtract(15, "minutes")
            .format("h:mm a");
          console.log(
            "check date and time----",
            res?.title,
            res?.session_end_date,
            res?.session_start_date,
            moment(res?.session_end_date).format("h:mm a"),
            moment(res?.session_start_date).format("h:mm a")
          );
          data.diffs = moment(diff[0]?.session_start_date).diff(today, "days");
          if (days.every((data) => data === null)) {
            data.days = res?.days;
          } else {
            console.log("inside days", days);
            data.days = res?.days;
          }
        } else {
          if (res?.cloud_type === "GCP") {
            let days = res?.training_dates.map((data) => data.day);
            let end_day_chk = moment.utc(res?.session_end_date);
            let start_day_chk = moment.utc(res?.session_start_date);
            data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
            data.startDate = moment(res?.session_start_date).format("Do MMM ");
            data.startTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_start_date).format("h:mm a")
                : moment(res?.session_start_date)
                    .add(15, "minutes")
                    .format("h:mm a");
            data.endTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_end_date).format("h:mm a")
                : moment(res?.session_end_date)
                    .subtract(15, "minutes")
                    .format("h:mm a");
            data.diffs = moment(res?.session_start_date).diff(
              moment(Date.now()),
              "days"
            );

            data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
            data.days = res?.days;
          } else {
            let days = res?.training_dates.map((data) => data.day);
            data.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
            data.startDate = moment(res?.session_start_date).format("Do MMM ");
            data.startTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_start_date).format("h:mm a")
                : moment(res?.session_start_date).format("h:mm a");
            data.endTime =
              res?.cloud_type === "GCP"
                ? moment(res?.session_end_date).format("h:mm a")
                : moment(res?.session_end_date).format("h:mm a");
            data.diffs = moment(res?.session_start_date).diff(
              moment(Date.now()),
              "days"
            );
            console.log("check date and time===aws", res?.title);
            console.log(
              "check date and time",
              res?.title,
              res?.session_end_date,
              res?.session_start_date,
              moment(res?.session_end_date).format("h:mm a"),
              moment(res?.session_start_date).format("h:mm a")
            );
            data.diffs = Math.sign(data.diffs) === -1 ? 0 : data.diffs;
            if (days.every((data) => data === null)) {
              data.days = res?.days;
            } else {
              data.days = [];
              data.days = days;
            }
          }
        }
        return data;
      });
      console.log("training_data_check=====", training_data);
      setTrainingList(training_data);
    } else {
      setIsLoading(false);
      setTrainingList([]);
    }
  }
  const multipleTraining = async (res) => {
    let data = await getdataBetweenDates(res);
    return 1;
    //  if(data.length == 0 ){
    //     return await getdates()
    //  }else{
    //   console.log("inseide else");
    //      return data
    //  }
  };
  const getdataBetweenDates = async (res) => {
    let data = [];
    let result = res?.training_dates.map(async (days) => {
      if (
        days.session_start_date >= startDate &&
        days.session_start_date <= endDate
      ) {
        console.log("veyon new traini----->>,", days);
        days.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
        days.startDate = moment(res?.session_start_date).format("Do MMM ");
        days.startTime = moment(res?.session_start_date).format("h:mm a");
        days.endTime = moment(res?.session_end_date).format("h:mm a");
        days.diffs = moment(res?.session_start_date).diff(
          moment(Date.now()),
          "days"
        );
        console.log("res?.day--------->>", res?.day);
        data.push(days);
        return days;
      } else {
        return await getdates(res);
      }
    });
    console.log("result----------------@@@@@@@@@@@@@@@", result);
    return 1;
  };
  const getdates = async (res) => {
    console.log("res----------->>", res);
    res.endDate = moment(res?.session_end_date).format("Do MMM YYYY");
    res.startDate = moment(res?.session_start_date).format("Do MMM ");
    res.startTime = moment(res?.session_start_date)
      .add(15, "minutes")
      .format("h:mm a");
    res.endTime = moment(res?.session_end_date)
      .subtract(15, "minutes")
      .format("h:mm a");
    res.diffs = moment(res?.session_start_date).diff(moment(Date.now()), "res");
    console.log("res?.day--------->>", res?.day);
    return res;
  };
  const getStudioList = async () => {
    const studiosResponse = await api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.STUDIO_LIST
      }`,
      { is_active: true }
    );
    if (studiosResponse.status === STATUS.OK) {
      const studioData = studiosResponse.data.data.rows.map((value) => ({
        id: value.id,
        key: value.id,
        label: value.studio_name,
        text: value.studio_name,
        value: value.id,
      }));
      console.log("studioData--$$$$$$$$--------->>>", studioData);
      setStudioList(studioData);
    } else {
      setStudioList([]);
    }
  };
  const getInstructorList = async () => {
    const queryParam = {
      // limit:limit || 10,
      // offset:offset || 0,
      is_active: true,
      role_id: 3,
    };
    let instructorResponse = "";
    if (role_code === ROLE.ADMIN) {
      const response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.USERS
        }`,
        queryParam
      );
      instructorResponse = response;
    } else if (role_code === ROLE.STUDIO_ADMIN) {
      const response = await api_call(
        "GET",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
          API.END_POINTS.STUD_ADMIN
        }`,
        {
          // limit:limit || 10,
          // offset:offset || 0,
          is_active: true,
          role_id: 3,
          studio_id: studio_id,
        }
      );
      instructorResponse = response;
    }
    if (instructorResponse.status === STATUS.OK) {
      const instructorVal = instructorResponse.data.data.rows.map((value) => ({
        id: value.id,
        key: value.id,
        label: value.name,
        text: value.name,
        value: value.id,
      }));
      setInstructorList(instructorVal);
    } else if (instructorResponse.status === STATUS.DATA_NOT_FOUND) {
      setInstructorList([]);
    }
  };
  const onPageClickhandler = (e, data) => {
    setOffset(Math.ceil((data - 1) * limit));
  };
  const setGridViewfun = () => {
    setGridview(!gridview);
  };
  useEffect(() => {
    if (role_code === "SUPER_ADMIN") {
      getStudioList();
    }
    getTrainingList();
    getInstructorList();
  }, []);
  useEffect(() => {
    console.log("PageCount----", pageCount);
    setOffset(0);
  }, [pageCount]);
  useEffect(() => {
    let filter = {
      searchBytrainingName: AllPageFilter?.TrainingFilter?.searchBytrainingName,
      studio: AllPageFilter?.TrainingFilter?.studio,
      instructor: AllPageFilter?.TrainingFilter?.instructor,
      startDate: AllPageFilter?.TrainingFilter?.startDate,
      endDate: AllPageFilter?.TrainingFilter?.endDate,
    };
    getTrainingList(filter);
  }, filterBody);
  return (
    <>
      {" "}
      <div className='scrollContainer'>
        {showTrainingListingDetails ? (
          ""
        ) : (
          <TrainingListingFilter
            setGridViewfun={setGridViewfun}
            gridview={gridview}
            showToggle={true}
            filter_fun={getTrainingList}
            instructorList={instructorList}
            studioList={studioList}
            getTrainingList={getTrainingList}
            state={state}
            roleCode={role_code}
            showTrainingListingDetails={showTrainingListingDetails}
          />
        )}{" "}
        {showTrainingListingDetails ? (
          <TrainingListingDetails
            trainingList={trainingList}
            training={trainingData}
            id={trainingID}
            showDetailPage={showDetailPage}
          />
        ) : (
          <>
            <>
              {trainingList?.length > 0 ? (
                <>
                  {" "}
                  <Box className='TrainingListMainContainer'>
                    {" "}
                    {!gridview ? (
                      isLoading ? (
                        <MultiLine_Spinner />
                      ) : (
                        <Grid container rowSpacing={4} columnSpacing={4}>
                          {" "}
                          {trainingList &&
                            trainingList.map((training) => {
                              // setTrainingData(training);
                              // setTrainingID(training?.id);
                              return (
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                  {" "}
                                  <div
                                    className='trainingListingContainer'
                                    onClick={() => gotoDetailsPage(training)}
                                  >
                                    {" "}
                                    <Grid container columnSpacing={10}>
                                      {" "}
                                      {console.log("mnnnnnnnn---", pageCount)}
                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}
                                        lg={10.5}
                                      >
                                        {" "}
                                        <Box>
                                          {" "}
                                          <Grid container>
                                            {" "}
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={0.5}
                                              lg={0.5}
                                            >
                                              {" "}
                                              {training?.cloud_type ===
                                              "GCP" ? (
                                                <img src={Google} height={20} />
                                              ) : (
                                                <img
                                                  src={Aws}
                                                  height={20}
                                                  style={{ marginTop: "5px" }}
                                                />
                                              )}
                                            </Grid>{" "}
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={6}
                                              lg={6}
                                            >
                                              {" "}
                                              <Box className='large_f_bold'>
                                                {" "}
                                                Training Name -{" "}
                                                {training?.title}
                                              </Box>{" "}
                                            </Grid>{" "}
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={5}
                                              lg={5}
                                            >
                                              {" "}
                                              <span
                                                className='TrainingListingUpcoming medium_f_bold'
                                                style={{
                                                  color:
                                                    training?.status_colour
                                                      ?.color,
                                                  background:
                                                    training?.status_colour
                                                      ?.background,
                                                }}
                                              >
                                                {" "}
                                                {
                                                  training?.status_colour
                                                    ?.status
                                                }
                                              </span>{" "}
                                            </Grid>{" "}
                                          </Grid>{" "}
                                        </Box>{" "}
                                        <Box className='trainingDetails'>
                                          {" "}
                                          {training?.description}
                                        </Box>{" "}
                                        <Box className='trainingDayTime'>
                                          {" "}
                                          <Grid container>
                                            {" "}
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={7}
                                              lg={7}
                                            >
                                              {" "}
                                              <Box className='medium_f_bold'>
                                                {" "}
                                                {training?.startDate} -{" "}
                                                {training?.endDate} -
                                                {training?.startTime} to{" "}
                                                {training?.endTime}
                                              </Box>{" "}
                                            </Grid>{" "}
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={5}
                                              lg={5}
                                            >
                                              {" "}
                                              <Box>
                                                {" "}
                                                <WeekDays
                                                  days={training?.days}
                                                  training_dates={
                                                    training?.training_dates
                                                  }
                                                  cloudType={
                                                    training?.cloud_type
                                                  }
                                                />{" "}
                                              </Box>{" "}
                                            </Grid>{" "}
                                          </Grid>{" "}
                                        </Box>{" "}
                                      </Grid>{" "}
                                      {(training?.status === "in-progress" ||
                                        training?.status === "pending") && (
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={12}
                                          lg={1.5}
                                        >
                                          {" "}
                                          <Box className='startInContainer'>
                                            {" "}
                                            <Grid
                                              container
                                              direction='row'
                                              justifyContent='space-between'
                                            >
                                              {" "}
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                className='start_in'
                                              >
                                                {" "}
                                                Start In
                                              </Grid>{" "}
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                className='no_of_days large_f_bold'
                                              >
                                                {" "}
                                                {training?.diffs}
                                              </Grid>{" "}
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                className='start_in_days'
                                              >
                                                {" "}
                                                Days
                                              </Grid>{" "}
                                            </Grid>{" "}
                                          </Box>{" "}
                                        </Grid>
                                      )}
                                    </Grid>{" "}
                                  </div>{" "}
                                </Grid>
                              );
                            })}
                        </Grid>
                      )
                    ) : isLoading ? (
                      <MultiLine_Spinner />
                    ) : (
                      <Grid container columnSpacing={3}>
                        {" "}
                        {trainingList.map((training) => {
                          // setTrainingData(training);
                          // setTrainingID(training?.id);
                          return (
                            <Grid item xs={12} sm={12} md={6} lg={4}>
                              {" "}
                              <div>
                                {" "}
                                <TrainingGridListing
                                  training={training}
                                  onClick={gotoDetailsPage}
                                />{" "}
                              </div>{" "}
                            </Grid>
                          );
                        })}
                        {/* <Grid container justifyContent={'end'}>                                    <Grid item>                                        <Pagination
                                            count={pageCount}
                                            onChange={onPageClickhandler}
                                        />                                    </Grid>                                </Grid> */}
                      </Grid>
                    )}
                  </Box>{" "}
                </>
              ) : (
                <div>{!isLoading && <NoDataFound />}</div>
              )}
              {isLoading && <MultiLine_Spinner />}
            </>
            {/* <Grid
						item
						justifyContent="flex-end"
						alignItems="flex-end"
						className="paginationTL"
					>
						{' '}
						<Pagination count={pageCount} onChange={onPageClickhandler} />{' '}
					</Grid>{' '} */}
          </>
        )}
      </div>
      {showTrainingListingDetails ? (
        ""
      ) : (
        <Grid
          item
          justifyContent='flex-end'
          alignItems='flex-end'
          className='paginationTL'
        >
          {" "}
          <Pagination
            count={pageCount}
            onChange={onPageClickhandler}
            disabled={pageCount === 1}
            hidePrevButton={offset === 0}
          />{" "}
        </Grid>
      )}
    </>
  );
};
export default TrainingListing;
